import dayjs from "dayjs";

/* Player data */
const playerDataTemplate = {
	languageId: null,
	userId: null,
	started: dayjs(new Date()).format('YYYY-MM-DD'),
	completed: null,
	modules: [],
	
};

export {playerDataTemplate};
